// extracted by mini-css-extract-plugin
export default {"icon":"Component_icon__8yi5l","field-icon":"Component_field-icon__FGpLP","file-icon":"Component_file-icon__UcMtl"};